module.exports = __webpack_public_path__ + "img/760037151.c590c3ab.svg";